export const SCHEDULE_TYPE_ASAP = -1;
export const SCHEDULE_TYPE_ASAP_PRIORITY = -11;
export const SCHEDULE_TYPE_FUTURE = 0;
